/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag jsx
 */

import { jsx } from '@atlaskit/css';
import { AgentAvatar } from '@atlaskit/rovo-agent-components';
import { type Agent } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

type PromptAgentAvatarProps = {
	agent: Agent;
};

export const PromptAgentAvatar = ({ agent }: PromptAgentAvatarProps) => {
	return (
		<AgentAvatar
			agentNamedId={agent.external_config_reference ?? agent.named_id}
			agentId={agent.id}
			agentIdentityAccountId={agent.identity_account_id}
			size="small"
			showBorder={false}
			isForgeAgent={agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE'}
			forgeAgentIconUrl={agent.icon}
		/>
	);
};
